(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lami-pourquoi-ami-sport"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlideshow(sectionId) {
    var wrapper = document.getElementById("ami-why-slideshow-" + sectionId);
    if (!wrapper) return;
    var slides = Array.from(wrapper.querySelectorAll(".ami-why__slide"));
    if (slides.length <= 1) return;
    var dots = Array.from(
      document.querySelectorAll(
        "[data-slideshow=\"ami-why-slideshow-" + sectionId + "\"]"
      )
    );
    var current = 0;
    var timer;
    function goTo(index) {
      slides[current].classList.remove("ami-why__slide--active");
      if (dots[current]) {
        dots[current].classList.remove("ami-why__dot--active");
        dots[current].setAttribute("aria-selected", "false");
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add("ami-why__slide--active");
      if (dots[current]) {
        dots[current].classList.add("ami-why__dot--active");
        dots[current].setAttribute("aria-selected", "true");
      }
    }
    function startTimer() {
      timer = setInterval(function () {
        goTo(current + 1);
      }, 4500);
    }
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        clearInterval(timer);
        goTo(parseInt(this.getAttribute("data-slide"), 10));
        startTimer();
      });
    });
    startTimer();
  }
  document.querySelectorAll("[id^=\"ami-why-slideshow-\"]").forEach(function (el) {
    var match = el.id.match(/^ami-why-slideshow-(.+)$/);
    if (match) initSlideshow(match[1]);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
